import { fg } from '@atlaskit/platform-feature-flags';
import type { AIHeaderImageStatus, GenerateImageProps } from '@atlassian/ai-image-generation/types';
import { useAIGeneratedCoverImage } from '@atlassian/ai-image-generation/use-ai-generated-cover-image';
import { useRemixImageGeneration } from '@atlassian/ai-image-generation/use-remix-image-generation';

import { useProductDependencies } from '../use-product-dependencies';

type CompanyHubImageGenerationResult = {
	aiHeaderImageFileId?: string;
	aiHeaderImageStatus?: AIHeaderImageStatus;
	error: string | null;
	generateImage: (props: GenerateImageProps) => Promise<string | undefined>;
};

export const useCompanyHubImageGeneration = ({
	contentId,
}: {
	contentId: string;
}): CompanyHubImageGenerationResult => {
	const { cloudId, createEditorMediaProvider, userId } = useProductDependencies();
	const legacyImageGeneration = useAIGeneratedCoverImage({ contentId });
	const remixImageGeneration = useRemixImageGeneration({
		cloudId,
		contentId,
		createEditorMediaProvider,
		userId,
	});

	if (fg('company_hub_migrate_image_gen_to_remix')) {
		return remixImageGeneration;
	}

	return {
		generateImage: legacyImageGeneration.generateImage,
		aiHeaderImageStatus: legacyImageGeneration.aiHeaderImageStatus,
		aiHeaderImageFileId: legacyImageGeneration.aiHeaderImageFileId,
		error: legacyImageGeneration.error,
	};
};
